import React from 'react';
import clsx from 'clsx';

function Loader({ text, withBackground = true, positionFixed = false }) {
    return (
        <div
            className={clsx(
                'loader',
                positionFixed && 'loader--fixed',
                withBackground && 'loader--with-background',
            )}
        >
            <div className="loader__circles">
                {[...Array(9)].map((_, i) => (
                    <div className={`loader__circle loader__circle-${i}`} key={i} />
                ))}
            </div>

            {text && <p className="loader__text">{text}</p>}
        </div>
    );
}

export { Loader };
